import { render, staticRenderFns } from "./CustomViewManager.vue?vue&type=template&id=88d90030&scoped=true&"
import script from "./CustomViewManager.vue?vue&type=script&lang=js&"
export * from "./CustomViewManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d90030",
  null
  
)

export default component.exports